export const NBS_XLSX_URL =
  'https://www.gov.br/nfse/pt-br/biblioteca/documentacao-tecnica/documentacao-atual/anexo_b-nbs2-lista_servico_nacional-snnfse.xlsx/@@download/file/ANEXO_B-NBS2-LISTA_SERVICO_NACIONAL-SNNFSe.xlsx';

export const NBS_GOLDEN_INTEGRACAO_SISTEMAS = '1.1502.50.00';
export const NBS_MIN_CODES = 800;
export const NBS_MAX_CODES = 950;
